import { Navigate } from 'react-router-dom';
import { useAppSelector } from '@/store/hooks';

/**
 * 루트(/) 리다이렉트 - 로그인 여부에 따라 분기
 * - 로그인 O → /my-campaigns
 * - 로그인 X → /login
 */
function RootRedirect() {
  const currentUser = useAppSelector((s) => s.envs.currentUser);
  const env = useAppSelector((s) => s.envs.env);

  // 환경 정보 로딩 중이면 아직 판단하지 않음
  if (!env) return null;

  if (currentUser) {
    return <Navigate to="/my-campaigns" replace />;
  }

  return <Navigate to="/login" replace />;
}

export default RootRedirect;
